import DocumentSchema from '@/components/DocumentSchema';
import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import { useValuationData } from '@/pages/CompanyReport/components/Valuation';
import type { Table } from 'schema-dts';
import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

export const FairRatioTable = () => {
  const {
    tickerSymbol,
    multiples: { preferredMultiple },
    formattedPreferredMultipleFairRatio,
  } = useValuationData();

  const t = useValuationTranslation();

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: t('vsFair.table.heading'),
          about: t('vsFair.table.description', {
            tickerSymbol,
            metric: preferredMultiple.name,
          }),
        }}
      />
      <ChartDataTable data-cy-id="key-metrics-table" columnTextAlignments="l">
        <caption>
          {t('vsFair.table.description', {
            tickerSymbol,
            metric: preferredMultiple.name,
          })}
        </caption>
        <thead>
          <tr>
            <th colSpan={2}>{t('vsFair.table.heading')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {t('vsFair.table.row.current', {
                metric: preferredMultiple.name,
              })}
            </td>
            <td>{preferredMultiple.value}</td>
          </tr>
          <tr>
            <td>
              {t('vsFair.table.row.fair', {
                metric: preferredMultiple.name,
              })}
            </td>
            <td>{formattedPreferredMultipleFairRatio}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};
